import React from 'react';
import { BrowserRouter as Router, Switch, Route, NavLink } from 'react-router-dom';
import Locations from './components/Locations';
import CharacterInfo from './components/CharacterInfo';
import Episodes from './components/Episodes';
import logo from './images/logo.png';
import Characters from './components/Characters';
import Header from './components/Header';
import Parallax from './components/Parallax';
import './app.scss';

function App() {
  return (
    <div>
      <Router>
        <nav className="navbar__box">
          <div className="navbar__item">
            <p className="navbar__item-p">
              <NavLink to="/" activeClassName="active" exact>Home</NavLink>
            </p>
          </div>
          <div className="navbar__item">
            <p className="navbar__item-p">
              <NavLink to="/characters" className="navbar__item-p">Characters</NavLink>
            </p>
          </div>
          <div className="navbar__item">
            <img
              className="navbar__item-logo"
              src={logo}
              alt="Rick and Morty logo"
            />
          </div>

          <div className="navbar__item">
            <p className="navbar__item-p">
              <NavLink to="/episodes" className="navbar__item-p">Episodes</NavLink>
            </p>
          </div>
          <div className="navbar__item">
            <p className="navbar__item-p">
              <NavLink to="/locations" className="navbar__item-p">Locations</NavLink>
            </p>
          </div>
        </nav>

        <Header />
        <Parallax title="School is not a place for smart people" />
        <Switch>
          <Route path="/" exact component={Characters} />
          <Route path="/episodes" component={Episodes} />
          <Route path="/characters" component={Characters} />
          <Route path="/locations" component={Locations} />
          <Route path="/character/:id" exact component={CharacterInfo} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
